import { render } from "./VerticalCheckBoxInput.vue?vue&type=template&id=82045800&scoped=true&lang=pug"
import script from "./VerticalCheckBoxInput.vue?vue&type=script&lang=js"
export * from "./VerticalCheckBoxInput.vue?vue&type=script&lang=js"

import "./VerticalCheckBoxInput.vue?vue&type=style&index=0&id=82045800&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82045800"]])

export default __exports__